import { IInvoiceDetrail } from './IInvoiceDetrail';
import { IinvoiceHeader } from './IinvoiceHeader';

export class IInvoice{
    country: string;
    header: IinvoiceHeader;
    details: IInvoiceDetrail[];
}